import { FC, useEffect, useState } from 'react'

import { getFilterInfo } from 'services/utilFunctions/getFilterInfo'
import FilterSelectionList from '../../UI/Filter/FilterSelectionList'
import FilterCollapsable from '../../UI/Filter/FilterCollapsable'
import BaseModalActions from 'components/Modals/BaseModalActions'
import { MFilters } from 'types/filterTypes'
import { FilterType } from 'services/types'

import { t } from 'translations'
import { Input, List } from 'ui'

type DropDownFiltersButtonModalProps = {
  contentName: MFilters.ContentTypes
  filters: string[]
}

const DropDownFiltersButtonModal: FC<DropDownFiltersButtonModalProps> = ({ filters, contentName }) => {
  const [userInput, setUserInput] = useState('')
  const [filteredFilterTypes, setFilteredFilterTypes] = useState<FilterType[]>([])
  const [show, setShow] = useState(false)

  // Filter the options depending on the userInput
  useEffect(() => {
    const filterTypes = getFilterInfo(filters)
    if (!userInput) {
      setFilteredFilterTypes(filterTypes)
      setShow(false)
      return
    }
    const filteredFilterTypes = filterTypes
      .map(filterType => {
        return { ...filterType, options: filterType.options.filter(option => option.label.toLowerCase().includes(userInput.toLowerCase())) }
      })
      .filter(({ options }) => options.length !== 0)

    // If there are less than 5 collapsable types sorted from the userInput, open them all (limit to 5 arbitrary)
    if (filteredFilterTypes.length < 5) setShow(true)
    else setShow(false)

    setFilteredFilterTypes(filteredFilterTypes)
  }, [filters, userInput])

  if (filters.length === 0) return null

  return (
    <BaseModalActions>
      <List className="pb-2">
        <List.Item className="p-2">
          <div className="input-group my-2">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="fa fa-search mr-1" />
              </span>
            </div>
            <Input
              type="text"
              variant="small"
              placeholder={t('searchBar.TYPE_TO_SEARCH')}
              aria-label="Search"
              value={userInput}
              onChange={e => setUserInput(e.target.value)}
              autoFocus
              onFocus={() => setUserInput('')}
            />
          </div>
          {filteredFilterTypes.map(filter => {
            return (
              <FilterCollapsable
                title={
                  <>
                    <i className={`fa ${filter.icon} mr-2`}></i>
                    <b>{filter.label} </b>
                  </>
                }
                type={filter.type}
                contentName={contentName}
                noPadding
                clearButton
                key={filter.key}
                show={show}
              >
                {({ isOpen }) => <FilterSelectionList filter={filter} contentName={contentName} advancedInput={userInput} isOpen={isOpen} />}
              </FilterCollapsable>
            )
          })}
        </List.Item>
      </List>
    </BaseModalActions>
  )
}

export default DropDownFiltersButtonModal
